module.exports = __webpack_public_path__ + "img/ic_accident_bl.3074fec1.svg";